import {
  IPanelProps,
  IPanelStyles,
  IStyle,
  PanelType,
  ScreenWidthMinLarge,
  ScreenWidthMinMedium,
  ScreenWidthMinUhfMobile,
  ScreenWidthMinXLarge,
  ScreenWidthMinXXLarge,
} from '@fluentui/react';

export const teamsPanelDimension = '800px';

// Following consts are used below in `getPanelBreakpoints()` function to provide
// necessary fallbacks for different types of Panel in different breakpoints.
const smallPanelSelectors = {
  [`@media (min-width: ${ScreenWidthMinMedium}px)`]: {
    width: teamsPanelDimension,
  },
};

const mediumPanelSelectors = {
  [`@media (min-width: ${ScreenWidthMinLarge}px)`]: {
    width: teamsPanelDimension,
  },
  [`@media (min-width: ${ScreenWidthMinXLarge}px)`]: {
    width: teamsPanelDimension,
  },
};

const largePanelSelectors = {
  [`@media (min-width: ${ScreenWidthMinUhfMobile}px)`]: {
    width: teamsPanelDimension,
  },
  [`@media (min-width: ${ScreenWidthMinXXLarge}px)`]: {},
};

const largeFixedPanelSelectors = {
  [`@media (min-width: ${ScreenWidthMinXXLarge}px)`]: {
    width: teamsPanelDimension,
  },
};

const extraLargePanelSelectors = {
  [`@media (min-width: ${ScreenWidthMinXXLarge}px)`]: {},
};

// Make sure Panels have fallbacks to different breakpoints by reusing same selectors.
// This is done in the effort to follow design redlines.
const getPanelBreakpoints = (type: PanelType): { [x: string]: IStyle } | undefined => {
  let selectors;

  // Panel types `smallFluid`, `smallFixedNear`, `custom` and `customNear`
  // are not checked in here because they render the same in all the breakpoints
  // and have the checks done separately in the `getStyles` function below.
  switch (type) {
    case PanelType.smallFixedFar:
      selectors = {
        ...smallPanelSelectors,
      };
      break;
    case PanelType.medium:
      selectors = {
        ...smallPanelSelectors,
        ...mediumPanelSelectors,
      };
      break;
    case PanelType.large:
      selectors = {
        ...smallPanelSelectors,
        ...mediumPanelSelectors,
        ...largePanelSelectors,
      };
      break;
    case PanelType.largeFixed:
      selectors = {
        ...smallPanelSelectors,
        ...mediumPanelSelectors,
        ...largePanelSelectors,
        ...largeFixedPanelSelectors,
      };
      break;
    case PanelType.extraLarge:
      selectors = {
        ...smallPanelSelectors,
        ...mediumPanelSelectors,
        ...largePanelSelectors,
        ...extraLargePanelSelectors,
      };
      break;
    default:
      break;
  }

  return selectors;
};

export const TeamsDetailPanelV2Styles = (props: IPanelProps): Partial<IPanelStyles> => {
  return {
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    main: [
      {
        borderRadius: '4px',
        boxSizing: 'border-box',
        position: 'relative',
        outline: '3px solid transparent',
        height: teamsPanelDimension,
        maxWidth: teamsPanelDimension,
        maxHeight: '100%',
        minHeight: '176px',
        minWidth: '288px',
        overflowY: 'auto',
        animation: 'none',
        ...getPanelBreakpoints(props.type!),
      },
    ],
  };
};
